import { Centro, Imagen, PilaV, Texto } from '../atomos';
import Logo from '@/assets/icons/new_logotipo_loading.svg';

const CargandoPantallaCompleta = (
  {
    mobile = false
  }) => {
  return (
    <Centro
      position="fixed"
      top={0}
      left={0}
      w="100vw"
      h="100dvh"
      bg="blackAlpha.700"
      zIndex={9999}
    >
      <PilaV spacing={6} alignItems="center">
        <Imagen
          src={Logo}
          h={mobile ? 144 : 201}
          alt="logo-agua"
        />
        <Texto color="white" fontSize="2xl" fontWeight="normal">
          Cargando...
        </Texto>
      </PilaV>
    </Centro>
  );
};

export default CargandoPantallaCompleta;
